import React from 'react';
import { useFormContext } from 'react-hook-form';
import Avatar from '@/components/common/Avatar';
import CloudinaryUploadWidget from '@/components/common/CloudinaryUploadWidget';
import DeleteButton from '@/components/common/DeleteButton';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import { ConstituentType } from '@/lib/types/ConstituentPropType';
import getInitials from '@/utils/getInitials';
import resizeCloudinaryImage from '@/utils/resizeCloudinaryImage';
import ConstituentField from '../constants/ConstituentField';

function AvatarField() {
  const { isSuperAdmin } = useCurrentUser();
  const { setValue, watch } = useFormContext();

  const avatar = watch(ConstituentField.AVATAR);
  const displayName = watch(ConstituentField.DISPLAY_NAME);
  const constituentType = watch(ConstituentField.CONSTITUENT_TYPE);
  const avatarInitials = getInitials(
    displayName,
    constituentType === ConstituentType.PRS,
  );

  const handleImageUpload = (e) =>
    setValue(ConstituentField.AVATAR, resizeCloudinaryImage(e.public_id, 128));

  const handleRemoveImage = () => setValue(ConstituentField.AVATAR, '');

  const ConstituentAvatar = (
    <Avatar size="80px" src={avatar}>
      {avatarInitials}
    </Avatar>
  );

  return (
    <div className="col-span-full">
      {isSuperAdmin ? (
        <div className="relative inline-block">
          <CloudinaryUploadWidget onSuccess={handleImageUpload}>
            {ConstituentAvatar}
          </CloudinaryUploadWidget>
          {avatar && (
            <DeleteButton
              onClick={handleRemoveImage}
              className="absolute -right-1 -bottom-1 bg-white shadow-sm"
              size="small"
            />
          )}
        </div>
      ) : (
        ConstituentAvatar
      )}
    </div>
  );
}

export default AvatarField;
